import React, { useEffect, useState } from "react";
import { Empty, Button, Checkbox, Select, Input } from "antd";
import useClientStore from "../../store/clientModal.store";
function CustomerTableSelectable({
  titleList,
  data,
  removeClientTA,
  clientName,
  isClickable = false,
  isEditField = true,
}) {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [checkBoxData, setCheckBoxData] = useState([]);
  const {  handleClientTAUpdate } = useClientStore();

  useEffect(() => {
    const checkBoxArray = data?.map((idx) => {
      return {
        TAName: idx?.name,
        ContactNumber: idx?.contact,
        Email: idx?.email,
        Role: idx?.role,
        Group: idx?.group,
        Lead: idx?.lead,
        Manager: idx?.manager,
      };
    });
    setCheckBoxData(checkBoxArray);
  }, []);

  const ResetCheckBox = () => {
    var checkBoxResetArray = data?.map((idx) => {
      return {
        TAName: idx?.name,
        ContactNumber: idx?.contact,
        Email: idx?.email,
        Role: idx?.role,
        Group: idx?.group,
        Lead: idx?.lead,
        Manager: idx?.manager,
      };
    });
    setCheckBoxData(checkBoxResetArray);
  };

  const onCheckBoxChange = (e) => {
    //console.log(e.target);
    if (e.target.checked) {
      checkBoxData[e.target.value].isSelected = true;
      //console.log("Setting checkBoxData", e.target.value, true, checkBoxData);
    } else {
      checkBoxData[e.target.value].isSelected = false;
      //console.log("Setting checkBoxData", e.target.value, false);
    }
    if (enableDbUpdate() == true) {
      setUpdateAvailable(true);
    } else {
      setUpdateAvailable(false);
    }
    setCheckBoxData(() => [...checkBoxData]);
  };

  function enableDbUpdate() {
    for (let idx = 0; idx < checkBoxData.length; idx++) {
      if (checkBoxData[idx].isSelected) {
        return true;
      }
    }
    return false;
  }

  const handleChange = (event, index) => {
    const { name, value } = event.target;
    const updatedValues = [...checkBoxData];
    updatedValues[index] = { ...updatedValues[index], [name]: value };
    setCheckBoxData(updatedValues);
  };

  const OnSelectChange = (value, field) => {
    //console.log(`selected ${value}`);
    const answer_array = value.split("#");
    var designation = answer_array[1];
    var idx = answer_array[0];
    var idxInt = parseInt(idx);
    setCheckBoxData(() => {
      const newArray = [...checkBoxData];
      if (field === "role") {
        newArray[idxInt].Role = designation;
      }
      return newArray;
    });
  };

  const getUpdated = (rowIndex) => {
    return checkBoxData[rowIndex]?.isSelected;
  };
  
  
  function getTimeNow() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate;
  }
  const encodeJson = (values) =>{
    let encodedJsonValues ={};
    var updateType=""
    //get company details
    const userData = JSON.parse(localStorage.getItem("userDetails"));
    encodedJsonValues.updatetype = "TA_INFO_UPDATE";
    //now fill the parameters
    encodedJsonValues.talist =[];
    let date = new Date();
    let timestamp = date.getTime();
    var num=0
    for(let idx = 0; idx < checkBoxData.length; idx++){
        //console.log("checkBoxData", idx,checkBoxData[idx].selected)
        if (checkBoxData[idx].isSelected) {
            encodedJsonValues.talist[num]={};
            encodedJsonValues.talist[num].oldtaname = data[idx].name;
            encodedJsonValues.talist[num].newtadetails = {};
            encodedJsonValues.talist[num].newtadetails.taname =checkBoxData[idx].TAName;
            encodedJsonValues.talist[num].newtadetails.tanumber =checkBoxData[idx].ContactNumber;
            encodedJsonValues.talist[num].newtadetails.tamail =checkBoxData[idx].Email;
            encodedJsonValues.talist[num].newtadetails.tarole =checkBoxData[idx].Role;
            encodedJsonValues.talist[num].newtadetails.tamanager =checkBoxData[idx].Manager;
            encodedJsonValues.talist[num].newtadetails.tagroup =checkBoxData[idx].Group;
            encodedJsonValues.talist[num].newtadetails.talead =checkBoxData[idx].Lead;
            encodedJsonValues.talist[num].newtadetails.taproject =data[idx].TAProject;
            encodedJsonValues.talist[num].newtadetails.taadditionadate =data[idx].addedDate;
             encodedJsonValues.talist[num].newtadetails.timestamp =timestamp;
            num=num+1
        } 
    }        
    //get the current date
    let newDate = getTimeNow()
    encodedJsonValues.updatedby= userData.qhuid;
    encodedJsonValues.updatedbyname= userData.username;
    encodedJsonValues.updatedon    = newDate;
        
    return encodedJsonValues
}

  const handleUpdate = () => {
    var jasonValues= encodeJson() 
    console.log("Encoded data", jasonValues)
    handleClientTAUpdate(clientName,jasonValues)
    ResetCheckBox();
    setUpdateAvailable(false);    
  }

  const handleRemove = () => {
    const removedTA = checkBoxData.filter((item) => item.isSelected);
    removedTA.forEach((element) => {
      removeClientTA(clientName, element.TAName);
    });
    setUpdateAvailable(false);
    ResetCheckBox();
  };

  return (
    <div className="rtable-selectable-wrapper">
      <div className="rtable-selectable-btn-wrapper">
        <Button
          className="rtable-selectable-btn"
          disabled={!updateAvailable}
          onClick={handleUpdate}
        >
          Update
        </Button>
        <Button
          className="rtable-selectable-btn"
          disabled={!updateAvailable}
          onClick={handleRemove}
        >
          Remove
        </Button>
      </div>
      <div
        className="rtable-title-wrapper"
        style={{
          gridTemplateColumns: `50px 50px 2fr 2fr 2fr repeat(${
            titleList.length - 5
          }, 2fr)`,
        }}
      >
        {titleList.map((title) => (
          <div className="rtable-title">{title}</div>
        ))}
      </div>
      {data?.map((table, rowIndex) => (
        <div
          key={table.id}
          className="rtable-info-wrapper"
          style={{
            gridTemplateColumns: `50px 50px 2fr 2fr 2fr repeat(${
              titleList.length - 5
            }, 2fr)`,
            cursor: isClickable && "pointer",
          }}
        >
          {Object.keys(table)?.map((tableInfo, idx) => (
            <div
              className={`rtable-info${
                tableInfo === "email" ? " rtable-info-email" : ""
              }`}
            >
              {isEditField ? (
                <div className="edit-field-wrapper">
                  <>
                    {tableInfo === "id" ? rowIndex + 1 : <></>}

                    {tableInfo === "select" ? (
                      <Checkbox
                        value={rowIndex}
                        onChange={onCheckBoxChange}
                        checked={getUpdated(rowIndex)}
                      ></Checkbox>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "name" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Input
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            name="TAName"
                            value={checkBoxData[rowIndex].TAName}
                            placeholder={checkBoxData[rowIndex].TAName}
                            onChange={(event) => handleChange(event, rowIndex)}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "contact" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Input
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            name="ContactNumber"
                            value={checkBoxData[rowIndex].ContactNumber}
                            placeholder={checkBoxData[rowIndex].ContactNumber}
                            onChange={(event) => handleChange(event, rowIndex)}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "email" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Input
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            name="Email"
                            value={checkBoxData[rowIndex].Email}
                            placeholder={checkBoxData[rowIndex].Email}
                            onChange={(event) => handleChange(event, rowIndex)}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "role" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Select
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            name="Role"
                            value={checkBoxData[rowIndex].Role}
                            onChange={(value) =>
                              OnSelectChange(value, tableInfo)
                            }
                            placeholder={checkBoxData[rowIndex].Role}
                            options={[
                              {
                                value: rowIndex + "#" + "TA",
                                label: "TA",
                              },
                              {
                                value: rowIndex + "#" + "Lead TA",
                                label: "Lead TA",
                              },
                              {
                                value: rowIndex + "#" + "Manager",
                                label: "Manager",
                              },
                            ]}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "group" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Input
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            name="Group"
                            value={checkBoxData[rowIndex].Group}
                            placeholder={checkBoxData[rowIndex].Group}
                            onChange={(event) => handleChange(event, rowIndex)}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "lead" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Input
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            name="Lead"
                            value={checkBoxData[rowIndex].Lead}
                            placeholder={checkBoxData[rowIndex].Lead}
                            onChange={(event) => handleChange(event, rowIndex)}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "manager" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Input
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            name="Manager"
                            value={checkBoxData[rowIndex].Manager}
                            placeholder={checkBoxData[rowIndex].Manager}
                            onChange={(event) => handleChange(event, rowIndex)}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}

                    {tableInfo === "project" ? table[tableInfo] : <></>}
                    {tableInfo === "addedDate" ? table[tableInfo] : <></>}
                  </>
                </div>
              ) : (
                table[tableInfo]
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default CustomerTableSelectable;
